import classNames from 'classnames'
import { ReactNode } from 'react'

import { MODAL_WRAPPER_X_PADDING } from '@apps-common/components/modals/modal/ModalContainer'

interface IProps {
  children: ReactNode
  innerClasses?: string
}

export const ModalFooter: React.FC<IProps> = ({ children, innerClasses }) => (
  <div
    className={classNames(
      MODAL_WRAPPER_X_PADDING,
      'absolute w-full left-0 bottom-0 bg-surface-2/30 backdrop-blur z-[5] pb-[max(env(safe-area-inset-bottom),1rem)] sm:pb-0'
    )}
  >
    <div className={classNames('pt-[1rem] pb-[1rem]', innerClasses)}>{children}</div>
  </div>
)
